import {Report as ReportComponent } from './Report'

export const Report = ReportComponent;